import { Link } from "react-router-dom";
import { PHONE_DISPLAY, ADDRESS_LINE1, ADDRESS_LINE2 } from "../../lib/site";

export const LEGAL_LINKS = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms-of-use", label: "Terms of Use" },
  { to: "/scrap-seller-policy", label: "Scrap Seller Policy" },
  { to: "/accessibility", label: "Accessibility" },
];

export const LegalFooter = () => (
  <footer className="bg-zinc-950 py-10 pb-24 lg:pb-10" data-testid="legal-footer">
    <div className="max-w-3xl mx-auto px-4 sm:px-6">
      <div className="flex items-center gap-3">
        <img src="/favicon.png" alt="Scrapman's mark" className="h-8 w-8" />
        <span className="font-heading text-white tracking-wide text-sm sm:text-base">
          SCRAPMAN'S METAL RECYCLING LLC
        </span>
      </div>
      <p className="mt-4 text-zinc-500 text-sm">
        {ADDRESS_LINE1}, {ADDRESS_LINE2} · {PHONE_DISPLAY}
      </p>
      <nav className="mt-4 flex flex-wrap gap-x-5 gap-y-2" data-testid="legal-footer-links">
        {LEGAL_LINKS.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            className="text-xs font-semibold uppercase tracking-wider text-zinc-400 hover:text-white transition-colors"
          >
            {l.label}
          </Link>
        ))}
      </nav>
      <p className="text-[11px] leading-relaxed text-zinc-600 mt-6">
        Website by{" "}
        <a
          href="https://webjesters.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-zinc-500 underline underline-offset-2 hover:text-zinc-400 transition-colors"
        >
          Webjesters
        </a>
      </p>
    </div>
  </footer>
);
